import { render } from "./StoreListView.vue?vue&type=template&id=2a053373&scoped=true&ts=true"
import script from "./StoreListView.vue?vue&type=script&lang=ts"
export * from "./StoreListView.vue?vue&type=script&lang=ts"

import "./StoreListView.vue?vue&type=style&index=0&id=2a053373&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a053373"]])

export default __exports__